import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { resetAuthState } from '../store/auth/Auth';
import {
    FiChevronDown, FiChevronRight, FiUser,
    FiSettings, FiLogOut, FiMenu,
    FiArrowLeft
} from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import { BarChart2, BookUser,Building2Icon, CheckSquare,FileText, Home, Mail, Bell, Settings, UserCheck, Users, Workflow } from 'lucide-react';

const Sidebar = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [openMenus, setOpenMenus] = useState({});
    const [profileOpen, setProfileOpen] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const profileRef = useRef(null);
    const userRole = useSelector((state) => state.auth.userdetails?.role?.toUpperCase());


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (profileRef.current && !profileRef.current.contains(event.target)) {
                setProfileOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

//     const handleMouseEnter = () => {
//     setSidebarCollapsed(false);
// };

useEffect(() => {
    const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
}, []);

const handleMouseEnter = () => {
    if (!isMobile) setSidebarCollapsed(false);
};

const handleMouseLeave = () => {
    if (!isMobile) {
        setSidebarCollapsed(true);
        setOpenMenus({});
    }
};

const handleMobileNavClick = () => {
    if (isMobile) {
        setSidebarCollapsed(true);
        setOpenMenus({});
    }
};


    // const toggleMenu = (menuName) => {
    //     setOpenMenus(prev => ({
    //         ...prev,
    //         [menuName]: !prev[menuName]
    //     }));
    //     if (sidebarCollapsed) setSidebarCollapsed(false);
    // };
const toggleMenu = (menuName) => {
    setOpenMenus(prev => ({
        ...prev,
        [menuName]: !prev[menuName]
    }));
};

    const toggleSidebar = () => {
        setSidebarCollapsed(!sidebarCollapsed);
    };

    const handleLogout = () => {
        dispatch(resetAuthState());
        navigate("/");
    };



    const navItems = [
        // {
        //     name: 'Dashboard',
        //     icon: <Home />,
        //     path: '/dashboard',
        // },
        {
            name: 'Dashboard',
            icon: <Home size={16}/>,
            path: '/dashboard',
            roles: ['ADMIN', 'USER', 'CUSTOMER']
        },
        {
            name: 'Client',
            icon: <Users  size={16}/>,
            // path: '/client-management',
            children: [
                { name: 'All clients', path: '/client-management', roles: ['ADMIN'] },
                { name: 'Register Form', path: '/registration-form-list', roles: ['ADMIN'] }
            ]

        },
        {
            name: 'Workflows',
            icon: <Workflow  size={16}/>,
            // roles: ['ADMIN', 'CUSTOMER', 'USER'],
            children: [
                { name: 'Workflows', path: '/workflows', roles: ['ADMIN'] },
                { name: 'Manage Template', path: '/workflows/template ', roles: ['ADMIN'] }
            ]
        },
         {
            name: 'Tasks',
            icon: <CheckSquare  size={16}/>,
            roles: ['ADMIN', 'CUSTOMER', 'USER'],
            path: "/tasks",
            // children: [
            //     { name: 'All Tasks', path: '/tasks', roles: ['ADMIN', 'CUSTOMER', 'USER'] },
            //     { name: 'Create Tasks', path: 'tasks/createTasks', roles: ['ADMIN', 'CUSTOMER', 'USER'] },
            // ]
        },
        {
            name: 'Leads',
            icon: <BookUser size={16}/>,
            path: "/leads",
            roles: ['ADMIN', 'CUSTOMER', 'USER'],
            // children: [
            //     { name: 'All Leads', path: '/leads', roles: ['ADMIN', 'CUSTOMER', 'USER'] },
            //     { name: 'Create Lead', path: '/leads/createleads', roles: ['ADMIN', 'CUSTOMER', 'USER'] }
            // ]
        },
        // {
        //     name: 'Accounts',
        //     icon: <Briefcase />,
        //     children: [
        //         { name: 'All Accounts', path: '/accounts' },
        //         { name: 'Create Account', path: '/accounts/createAccounts' }
        //     ]
        // },
       
        // {
        //     name: 'Meetings',
        //     icon: <Calendar  size={16}/>,
        //     roles: ['ADMIN', 'CUSTOMER', 'USER'],
        //     path: '/meetings',
        //     // children: [
        //     //     { name: 'All Meeting', path: '/meetings', roles: ['ADMIN', 'CUSTOMER', 'USER'] },
        //     // ]
        // },
        {
            name: 'Reports',
            icon: <BarChart2  size={16}/>,
            // path: '/reports'
            children: [
                { name: 'Reports', path: '/reports', roles: ['ADMIN'] },
                { name: 'Profit & Loss', path: '/profit-and-loss', roles: ['ADMIN'] },
                { name: 'BSheet', path: '/bsheet', roles: ['ADMIN'] },
            ]
        },

        // {
        //     name: 'GST',
        //     icon: <Building />,
        //     path: '/advancedGSTFeatures',
        //     roles: ['ADMIN']

        // },


        // {
        //     name: 'Document Center',
        //     icon: <FileText />,
        //     path: '/document-center',
        //     roles: ['ADMIN']

        // },
        
        // {
        //     name: 'Reports & Analytics',
        //     icon: <BarChart3 />,
        //     path: '/reports-analytics',
        //     roles: ['ADMIN']

        // },
        // {
        //     name: 'TDS Management',
        //     icon: <Calculator />,
        //     path: '/tds-management',
        //     roles: ['ADMIN']

        // },
        // {
        //     name: 'Invoice Generator',
        //     icon: <FileText />,
        //     path: '/invoice-generator',
        //     roles: ['ADMIN']

        // },
        // {
        //     name: 'Compliance Calendar',
        //     icon: <Calendar />,
        //     path: '/compliance-calendar'
        // },
        {
            name: 'Invoice Template',
            icon: <FileText  size={16}/>,
            path: '/invoice',
            roles: ['ADMIN']

        },
        {
            name: 'User Management',
            icon: <UserCheck size={16} />,
            path: '/user-management',
            roles: ['ADMIN']

        },
        // {
        //     name: 'Subscription',
        //     icon: <CreditCard />,
        //     path: '/subscription',
        //     roles: ['ADMIN']

        // },
        {
            name: 'Compliance',
            icon: <CheckSquare size={16}/>,
            roles: ['ADMIN', 'USER'],
            children: [
                { name: 'Tracker', path: '/compliance/tracker', roles: ['ADMIN', 'USER'] },
                { name: 'Notifications', path: '/compliance/notifications', roles: ['ADMIN', 'USER'] }
            ]
        },
        {
            name: 'Email Management',
            icon: <Mail size={16}/>,
            roles: ['ADMIN'],
            children: [
                { name: 'Email Templates', path: '/email/templates', roles: ['ADMIN'] },
                { name: 'Email Scheduler', path: '/email/schedules', roles: ['ADMIN'] },
                { name: 'Email History', path: '/email/history', roles: ['ADMIN'] }
            ]
        },
        {
            name: 'Organization',
            icon: <Building2Icon  size={16}/>,
            path: '/organization',
            roles: ['ADMIN']

        },
        {
            name: 'Settings',
            icon: <Settings  size={16}/>,
            path: '/settings',
            roles: ['ADMIN']

        },
        // {
        //     name: 'Documentation',
        //     icon: <Dock />,
        //     path: '/documentation',
        //     roles: ['ADMIN']

        // },


        // {
        //     name: 'Compliance Calendar',
        //     icon: <Calendar />,
        //     path: '/client-management'
        // },
    ];


    const filterNavByRole = (items, role) => {
        return items
            .filter(item => {
                if (role === 'ADMIN') return true;
                const hasAccess = !item.roles || item.roles.includes(role);
                return hasAccess;
            })
            .map(item => {
                if (item.children) {
                    return {
                        ...item,
                        children: filterNavByRole(item.children, role)
                    };
                }
                return item;
            })

            .filter(item => (item.path || (item.children && item.children.length > 0)));
    };
    const filteredNavItems = filterNavByRole(navItems, userRole);

    const isActive = (path) => location.pathname === path;
    const isChildActive = (children) => {
        return children?.some(child =>
            child.path ? isActive(child.path) : isChildActive(child.children)
        );
    };


    const renderMenuItem = (item, depth = 0) => {
        const hasChildren = item.children && item.children.length > 0;
        const isOpen = openMenus[item.name];
        const active = item.path ? isActive(item.path) : isChildActive(item.children);

        const commonClasses = `flex items-center w-full py-1 rounded-lg transition-all duration-150 ease-in-out no-underline 
  ${active ? 'text-[#fff] bg-primary font-semibold mt-1' : 'text-[#fff] hover:bg-gray-100 hover:text-blue-800'}
  ${sidebarCollapsed ? 'justify-center px-0' : 'px-2'}`;

        return (
            <li key={item.name} className="mb-1">
                {!hasChildren ? (
                    // <Link
                    //     to={item.path}
                    //     className={commonClasses}
                    //     style={{ paddingLeft: `${sidebarCollapsed ? '0' : `${depth * 12 + 12}px`}` }}
                    // >
                    <Link
    to={item.path}
    onClick={handleMobileNavClick}
    className={commonClasses}
    style={{ paddingLeft: `${sidebarCollapsed ? '0' : `${depth * 12 + 12}px`}` }}
>

                        <span className="flex items-center justify-center">
                            {item.icon}
                        </span>
                        {!sidebarCollapsed && <span className="ml-2 text-sm">{item.name}</span>}
                    </Link>
                ) : (
                    <>
                        <button
                            onClick={() => toggleMenu(item.name)}
                            className={commonClasses}
                            style={{ paddingLeft: `${sidebarCollapsed ? '0' : `${depth * 12 + 12}px`}` }}
                        >
                            <div className={`flex items-center ${sidebarCollapsed ? 'w-full justify-center' : 'w-full'}`}>
                                <span className="flex items-center">
                                    {item.icon}
                                    {!sidebarCollapsed && <span className="ml-2 text-sm">{item.name}</span>}
                                </span>
                                {!sidebarCollapsed && (
                                    isOpen ? <FiChevronDown className="ml-auto" /> : <FiChevronRight className="ml-auto" />
                                )}
                            </div>
                        </button>

                        {!sidebarCollapsed && (
                            <AnimatePresence>
                                {isOpen && (
                                    <motion.ul
                                        initial={{ opacity: 0, height: 0 }}
                                        animate={{ opacity: 1, height: 'auto' }}
                                        exit={{ opacity: 0, height: 0 }}
                                        transition={{ duration: 0.2 }}
                                        className="overflow-hidden"
                                    >
                                        {item.children.map(child => renderMenuItem(child, depth + 1))}
                                    </motion.ul>
                                )}
                            </AnimatePresence>
                        )}
                    </>
                )}
            </li>
        );
    };
    return (
        <div className="flex h-screen">
            <motion.div
             onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
                className={`bg-sidecolor text-[#fff] shadow-sm border-r flex flex-col ${sidebarCollapsed ? 'w-14' : 'w-65'}`} // w-4 = 1rem (16px)
                initial={{ width: 200 }}
                animate={{ width: sidebarCollapsed ? 43 : 200 }}
                transition={{ duration: 0.2 }}
            >
                <div className="px-1 py-1 border-b flex items-center justify-between">
                    {!sidebarCollapsed && (
                        <Link to="/dashboard">
                            {/* <img src="/logo1.png" alt="Logo" className="h-8 cursor-pointer" /> */}
   <img
  src="/logo1.png"
  alt="Logo"
  className="h-8 cursor-pointer filter contrast-200 brightness-150"
/>
                            
                        </Link>
                    )}

                    <button
                        onClick={toggleSidebar}
                        className="p-1 rounded-md hover:bg-primary flex items-center justify-center"
                    >
                        {sidebarCollapsed ? <FiMenu size={20} /> : <FiArrowLeft size={20} />}
                    </button>
                </div>

                <nav className="flex-1 overflow-y-auto py-1 ">
                    <ul className="space-y-1 px-1">
                        {filteredNavItems.map(item => renderMenuItem(item))}
                    </ul>
                </nav>

                <div className="px-1 py-0.5 relative " ref={profileRef}>
                    <button
                        onClick={() => setProfileOpen(!profileOpen)}
                        className={`flex items-center text-[#fff] w-full px-2 rounded-lg hover:bg-gray-100 transition-colors hover:text-blue-800 ${sidebarCollapsed ? 'justify-center' : ''}`}
                    >
                        <FiUser />
                        {!sidebarCollapsed && <span className="ml-2">Profile</span>}
                        {!sidebarCollapsed && (profileOpen ? (
                            <FiChevronDown className="ml-auto" />
                        ) : (
                            <FiChevronRight className="ml-auto" />
                        ))}
                    </button>

                    {!sidebarCollapsed && (
                        <AnimatePresence>
                            {profileOpen && (
                                <motion.div
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ duration: 0.15 }}
                                    className="absolute bottom-full left-0 right-0 mb-2 mx-4 bg-white rounded-md shadow-lg overflow-hidden"
                                >
                                    <Link
                                        to="/profile"
                                        className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-800 transition-colors no-underline"
                                    >
                                        <FiUser className="mr-3" />
                                        Profile
                                    </Link>
                                    <Link
                                        to="/settings"
                                        className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-800 transition-colors no-underline"
                                    >
                                        <FiSettings className="mr-3" />
                                        Settings
                                    </Link>
                                    <button
                                        onClick={handleLogout}
                                        className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-800 transition-colors no-underline"
                                    >
                                        <FiLogOut className="mr-3" />
                                        Logout
                                    </button>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    )}
                </div>
            </motion.div>

        </div>
    );
};

export default Sidebar;